var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47192 11.5578L7.47191 11.5579C7.44528 11.5986 7.40206 11.6257 7.35346 11.6319C7.30517 11.6381 7.25649 11.6228 7.22031 11.5899C7.2203 11.5899 7.22029 11.5899 7.22028 11.5899L4.28698 8.92327C4.21887 8.86135 4.21385 8.75595 4.27577 8.68783C4.33769 8.61972 4.44309 8.61471 4.51119 8.67662L4.5112 8.67663L6.866 10.8173L7.2999 11.2118L7.62082 10.721L11.7263 4.44207C11.7767 4.36502 11.8799 4.34342 11.957 4.39378C12.034 4.44419 12.0556 4.54749 12.0053 4.62448L12.4238 4.89811L12.0053 4.62449L7.47192 11.5578Z",
    fill: "#09090B",
    stroke: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.72eda6ba35e7a75729156236be81a2a5.svg";
export { ForwardRef as ReactComponent };